<template>
  <div class="text-left">
    <v-card>
      <v-form ref="form" class="pa-6" lazy-validation>
        <SoftwareFields
          :software="software"
          :editor-ready="editorReady"
          :allow-image-upload="Boolean(software.id)"
          :image-upload-created="Boolean(software.id)"
          :image-upload-path="imageUploadPath"
          @update="updateField"
        />

        <v-divider />
        <div class="text-center mt-4">
          <v-btn text @click="$router.back()">
            <v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}
          </v-btn>
          <v-btn color="primary" class="ml-2" @click="save">
            <v-icon left>mdi-content-save</v-icon>{{ $t("button.save") }}
          </v-btn>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import SoftwareFields from "@/components/software/SoftwareFields.vue";
import {
  createDefaultSoftware,
  normalizeSoftware,
  serializeSoftware
} from "@/utils/software";

export default {
  name: "EditSoftwareDetail",
  components: { SoftwareFields },
  data: () => ({
    software: createDefaultSoftware(),
    editorReady: false
  }),
  computed: {
    imageUploadPath() {
      return this.software.id
        ? `${this.$store.state.endpoint}/software/${this.software.id}`
        : "";
    }
  },
  created() {
    if (this.$route.params.id > -1) {
      this.getSoftware();
    } else {
      this.editorReady = true;
    }
  },
  methods: {
    updateField(field, value) {
      this.$set(this.software, field, value);
    },
    getSoftware() {
      axios
        .get(`${this.$store.state.endpoint}/software/${this.$route.params.id}`)
        .then(response => {
          this.software = normalizeSoftware(response.data);
        })
        .catch(error => {
          console.error(error);
          this.$store.commit("alert", {
            color: "error",
            text: this.$t("message.error.loadData")
          });
        })
        .finally(() => {
          this.editorReady = true;
        });
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      const editing = this.$route.params.id > -1;
      const path = editing
        ? `${this.$store.state.endpoint}/software/${this.$route.params.id}`
        : `${this.$store.state.endpoint}/software`;
      axios({
        method: editing ? "patch" : "post",
        url: path,
        data: serializeSoftware(this.software)
      })
        .then(() => {
          this.$store.commit("alert", {
            color: "success",
            text: this.$t(editing ? "message.correct.updateItem" : "message.correct.createItem")
          });
          this.$router.push("/manage/edit/softwares");
        })
        .catch(error => {
          this.$store.commit("alert", {
            color: "error",
            text: error.response ? error.response.data : error.message
          });
        });
    }
  }
};
</script>
